import type { Theme } from '@emotion/react'
import { css } from '@emotion/react'
import { breakpoint, size } from '@twistopayments/design-system/styles'

export const authButton = css`
  padding: ${size[8]} ${size[28]};
  text-align: center;
  cursor: pointer;

  ${breakpoint.up('smMd')} {
    padding: ${size[12]} ${size[48]};
  }
`

export const loginButton = {
  light: (theme: Theme) => css`
    color: ${theme.palette.primary.maxContrast};
  `,
  dark: (theme: Theme) => css`
    color: ${theme.palette.secondary.reversedContrast};
  `,
}

export const benefitsModal = css`
  max-width: 860px;
`
export const modalContent = css`
  width: 100%;
  display: flex;
  flex-direction: column;
  position: relative;

  ${breakpoint.up('smMd')} {
    flex-direction: row;
  }
`

export const closeButton = (theme: Theme) => css`
  display: none;
  position: absolute;
  cursor: pointer;
  right: 0;
  top: 0;
  border-bottom-left-radius: ${theme.borderRadius.xxl};
  border-top-right-radius: 0;
  padding: 0;
  margin: 0;
  z-index: 2;
  border: 0;
  color: #1a0826ff;
  font-weight: 500;
  width: ${size[48]};
  height: ${size[48]};
  text-align: center;
  background-color: transparent;

  &:after {
    content: '';
    display: block;
    position: absolute;
    right: -40px;
    top: -40px;
    background: #9c919e1e;
    width: 100px;
    height: 100px;
    border-bottom-left-radius: ${theme.borderRadius.xxl};
  }

  ${breakpoint.up('smMd')} {
    display: block;
  }
`

export const signUpPreviewButton = css`
  margin-top: ${size[20]};
`

export const headline = css`
  font-size: ${size[28]};
  font-weight: 600;
  line-height: 1.2;

  ${breakpoint.up('smMd')} {
    font-size: ${size[32]};
  }
`

export const authPreview = css`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;

  gap: ${size[20]};
  padding: ${size[48]};
`

export const icon = (theme: Theme) => css`
  path {
    fill: ${theme.palette.primary.maxContrast};
  }
`
export const benefits = (theme: Theme) => css`
  background: ${theme.palette.background.main};
  border-radius: ${theme.borderRadius.md} ${theme.borderRadius.lg};
  width: 100%;
  padding: ${size[28]};

  ${breakpoint.up('smMd')} {
    max-width: 380px;
    padding: ${size[48]};
  }
`

export const benefitsTitle = css`
  font-size: ${size[20]};
  font-weight: 600;
  line-height: 1.5;

  ${breakpoint.up('smMd')} {
    font-size: ${size[24]};
  }
`

export const benefitList = css`
  padding-left: 0;
  margin-top: ${size[28]};
  list-style: none;
  display: flex;
  flex-direction: column;
  gap: ${size[40]};

  li {
    display: flex;
    gap: ${size[20]};
    align-items: center;
  }

  ${breakpoint.up('smMd')} {
    max-width: 230px;
  }
`
